export const messageGroupsQueryKeys = {
  list: (companyId: string | number | null | undefined) => ["messageGroups", "list", companyId] as const,
  summary: (companyId: string | number | null | undefined, groupUid: string | undefined) =>
    ["messageGroups", "summary", companyId, groupUid] as const,
  messages: (companyId: string | number | null | undefined, groupUid: string | undefined) =>
    ["messageGroupMessages", companyId, groupUid] as const,
};
